import * as React from "react";

export const Colors = {
    Base: window.defaultTheme?.baseColor ?? "#eb6e1a",
    DrawerBackground: "#3a3f51",
};

export const drawerWidth = 240;

export const headerHeight = 64;

export const labelStyle: React.CSSProperties = {
    padding: 4,
    fontSize: "1rem",
};

export const valueStyle: React.CSSProperties = {
    padding: 6,
};
